import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import '../Marcas/Marcas.css'; // Reusing Marcas styles
import Swal from 'sweetalert2';
import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import EmpresaForm from "../Components/EmpresaForm/EmpresaForm";
import { useAuth } from "../Context/auth";

function EditarEmpresa() {
    const { id: empresaId } = useParams();
    const { currentUser, appUserData } = useAuth();
    const navigate = useNavigate();

    // Verifica permissão de edição
    useEffect(() => {
        if (appUserData && !appUserData['editar_empresas']) {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não tem permissão para editar empresas.',
                confirmButtonColor: '#2185c6'
            }).then(() => {
                navigate('/app/home');
            });
        }
    }, [appUserData, navigate]);

    const [initialData, setInitialData] = useState(null);
    const [mensagem, setMensagem] = useState('');
    const [loadingData, setLoadingData] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const fetchEmpresaData = async () => {
            if (!currentUser || !empresaId) return;
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/empresas/${empresaId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error("Empresa não encontrada.");
                const data = await response.json();
                setInitialData(data);
            } catch (error) {
                setMensagem("Erro ao carregar dados da empresa.");
            } finally {
                setLoadingData(false);
            }
        };
        fetchEmpresaData();
    }, [empresaId, currentUser]);

    async function handleAlterarEmpresa(formData) {
        setMensagem('');
        setSaving(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/empresas/${empresaId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formData)
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Falha ao atualizar empresa.");
            }
            navigate('/app/empresas');
        } catch (erro) {
            setMensagem(erro.message);
        } finally {
            setSaving(false);
        }
    }

    if (loadingData) return (
        <div className="marcas-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="d-flex justify-content-center align-items-center h-100">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Carregando...</span>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="marcas-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="marcas-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/empresas')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="marcas-title m-0">
                            Editar <span className="highlight">Empresa</span>
                        </h1>
                    </div>
                </div>

                <main className="marcas-content" style={{ maxWidth: '98%' }}>
                    {mensagem && (
                        <div className="alert alert-danger d-flex align-items-center mb-4" role="alert">
                            <i className="fas fa-exclamation-circle me-2"></i>
                            <div>{mensagem}</div>
                        </div>
                    )}

                    {initialData ? (
                        <EmpresaForm
                            initialData={initialData}
                            onSubmit={handleAlterarEmpresa}
                            isEditing={true}
                            loading={saving}
                        />
                    ) : <p>Nenhum dado para exibir.</p>}
                </main>
            </div>
        </div>
    );
}
export default EditarEmpresa;